import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/PolicyConflictsIndexStepQuery.graphql.ts';
import type {
	GlobalPolicyConflictsPageExtraProps,
	GlobalPolicyConflictsPageQueries,
} from './GlobalPolicyConflictsPage.entrypoint.types.tsx';

type GlobalPolicyConflictsPageEntryPointComponent = EntryPointComponent<
	GlobalPolicyConflictsPageQueries,
	{},
	{},
	GlobalPolicyConflictsPageExtraProps
>;

const toProjectPolicyAri = ({
	siteId,
	activationId,
	policyId,
}: {
	siteId: string;
	activationId: string;
	policyId: string;
}): string => `ari:cloud:jira:${siteId}:project-policy/activation/${activationId}/${policyId}`;

export const globalPolicyConflictsPageEntryPoint: EntryPoint<
	GlobalPolicyConflictsPageEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<GlobalPolicyConflictsPageEntryPointComponent>(
		/* webpackChunkName: "async-guided-autonomy-remediation-global" */ './GlobalPolicyConflictsPage.tsx',
	),
	getPreloadProps: ({ context: { match }, tenantContext }: EntryPointRouteParams) => {
		const extraProps: GlobalPolicyConflictsPageExtraProps = {
			kind: 'global',
			policyId: match.params.policyId ?? undefined,
			isAdmin: tenantContext.isAdmin,
		};

		if (!extraProps.isAdmin || extraProps.policyId == null) {
			return { extraProps };
		}

		return {
			extraProps,
			queries: {
				globalPolicyConflictsPage: {
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
					parameters,
					variables: {
						policyId: toProjectPolicyAri({
							siteId: tenantContext.cloudId,
							activationId: tenantContext.activationId,
							policyId: extraProps.policyId,
						}),
					},
				},
			},
		};
	},
});
